import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../../../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SchoolService } from '../../../../../../services/school.service';
import { ClassService } from '../../../../../../services/class.service';
import { UserStatus, UserType } from '../../../../../../model/Const';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CoursewareService, Paragraph } from '../../../../../../services/courseware.service';
import { TwNoticeService } from '../../../../../../services/tw-notice.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { UploadImageWithPreviewComponent } from '../../../../../common/upload-image-with-preview/upload-image-with-preview.component';
import {
  UploadImageWithPreviewV2Component
} from '../../../../../common/upload-image-with-preview-v2/upload-image-with-preview-v2.component';
import { HWResourceService } from '../../../../../../services/huawei-resource.service';
import { WavePlayerV2Component } from '../../../../../common/wave-player-v2/wave-player-v2.component';


@Component({
    selector: 'app-admin-resource-book-item-audio',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    standalone: false
})
export class AdminResourceBookItemQuizComponent implements OnInit {

  quizzes_relate: any = [];
  _quizSelection = new Map<string|number, any>();
  book_id = 0;
  res_type = 'exercise';
  bisType = '';
  pageTitle = '';
  showQuizSelectDialog = false;

  constructor(private userService: UserService,
              private clsService: ClassService,
              private schoolService: SchoolService,
              private coursewareService: CoursewareService,
              private activatedRoute: ActivatedRoute ,
              private twNoticeService: TwNoticeService ,
              private router: Router ,
              private fb: UntypedFormBuilder,
              private nzMessageService: NzMessageService) {
    this.bisType = this.activatedRoute.pathFromRoot[2].snapshot.url[2].path;
    this.activatedRoute.params.subscribe( params => {
      this.book_id = params['item_id'] || 0;

    });
    this.activatedRoute.title.subscribe({
      next: (title) => {
        this.pageTitle = title || '';
      }
    });
  }
  ngOnInit() {
    this.coursewareService.getAssociateResources(this.book_id, this.res_type).then((res: any) => {
      console.log('getAssociateResources', res);
      this.quizzes_relate = res; // .map((r: any) => r.resource_id).join(', ');
    }).catch((err: any) => {
      console.log('getAssociateResources', err);
      this.nzMessageService.error('加载失败');
    });
  }
  save(evt: any) {
    // if (this.quizzes_relate.length == 0) {
    //   this.nzMessageService.error('关联quiz不能为空');
    //   return;
    // }
    const data = this.quizzes_relate.map((a: any) => parseInt(a.id, 10));
    this.coursewareService.setAssociateResources(this.book_id, this.res_type, data).then((res: any) => {
      console.log('setAssociateResources', res);
      this.nzMessageService.success('保存成功');
    }).catch((err: any) => {
      console.log('setAssociateResources', err);
      this.nzMessageService.error('保存失败');
    });

  }


  set quizSelection (value: any) {
    console.log('set quizSelection', value.get(0));
    this.quizzes_relate.push(value.get(0));
    this.showQuizSelectDialog = false;
  }
  get quizSelection () {
    return this._quizSelection;
  }

  closeQuizSelectDialog () {
    this.showQuizSelectDialog = false;
  }

  editQuiz(quiz: any) {
    this.router.navigate([`/admin/v3/resource/exercise/edit/16/index?tabIndex=1`]);
  }

  deleteQuiz (quiz: any) {
    const index = this.quizzes_relate.findIndex((q: any) => {
      return q.id === quiz.id;
    });
    this.quizzes_relate.splice(index, 1);
  }
}
